import apiAuctionsOPL from '../../api/apiAuctionsOPL'

const state = {
    status: false,
    result: [],
    query: {
        brand: '',
        'models': [],
        'grades': [],
        yearMin: 2006,
        yearMax: new Date().getFullYear(),
        kmsMin: null,
        kmsMax: null,
        priceMin: null,
        priceMax: null,
        ccMin: null,
        ccMax: null,
        date: null,
        'dates': [],
        carGrade: null,
        'chassis': [],
        'transmissions': [],
        'lots': [],
        'colors': [],
        'equipment': [],
        'auctions': [],
        'regions' : [],
        order_column: 'AUCTION_DATE',
        order_type: 'DESC',
        limit_start: 0,
        limit_end: 30,
    }
}

const getters = {
    getStatsStatusOPL: (state) => {
        return state.status
    },
    getStatsQueryOPL: (state) => {
        return state.query
    },
    getStatsResultOPL: (state) => {
        return state.result
    }
}

const mutations = {
    updateStatsStatusOPL: (state, value) => {
        state.status = value
    },
    updateStatsQueryFieldOPL: (state, input) => {
        state.query[input.field] = input.value
    },
    pushStatsResultOPL: (state, value) => {
        state.result = state.result.concat(value)
    },
    updateStatsResultOPL: (state, value) => {
        state.result = value
    },
    updateStatsQueryOPL: (state, query) => {
        const notAllowed = ['order_column', 'order_type', 'page', 'auctionType'];

        Object.keys(query)
            .filter(key => notAllowed.includes(key))
            .forEach(key => delete query[key])


        for (const [key, value] of Object.entries(query)) {
            state.query[key] = value
        }
        
    }
}

const actions = {
    setStatsStatusOPL: ({ commit }, value) => {
        commit('updateStatsStatusOPL', value)
    },
    setStatsQueryFieldValueOPL: ({ commit }, value) => {
        commit('updateStatsQueryFieldOPL', value)
    },
    fetchStatsResultOPL: ({commit, state, dispatch}) => {
        dispatch('setSearchResultsLoadingStatusOPL', true)
        apiAuctionsOPL
            .getPastResult(state.query)
            .then((response) => {
                console.log(response.data)
                commit('updateStatsResultOPL', response.data.results)
                dispatch('setAdvanceSearchResultTotalLotsNumberOPL', response.data.totalNumber[0].TAG0)
                dispatch('setSearchResultsLoadingStatusOPL', false)
            })
            .catch((error) => {
                dispatch('setSearchResultsLoadingStatusOPL', false)
                console.log(error)
            })
    },
    loadMoreStatsResultsOPL: ({ commit, state }) => {
        commit('updateStatsQueryFieldOPL', { field: 'limit_start', value: state.query.limit_start + 30 })
        commit('updateStatsQueryFieldOPL', { field: 'limit_end', value: state.query.limit_end + 30 })
        apiAuctionsOPL
            .getPastResult(state.query)
            .then((response) => {
                commit('pushStatsResultOPL', response.data.results)
            })
            .catch((error) => {
                console.log(error)
            })
    },
    mergeStatsQueryWithSearchOPL: ({ commit }, value) => {
        commit('updateStatsQueryOPL', value)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/statisticsOPL.js